import { useCallback, useState } from "react";

type UseRefreshProps = {
    refresh?: () => Promise<unknown>;
};

export const useRefresh = ({ refresh }: UseRefreshProps) => {
    const [refreshing, setRefreshing] = useState(false);
    const localRefresh = useCallback(() => {
        void (async () => {
            setRefreshing(true);
            try {
                if (refresh) {
                    await refresh();
                }
            } finally {
                setRefreshing(false);
            }
        })();
    }, [refresh]);

    return { refreshing, ...(refresh ? { localRefresh } : {}) };
};
